import { useSupabase } from "../context/SupabaseContext";
import { isSuperAdminEmail } from "../constants/superadmin";

// Returns whether the signed-in user is a superadmin (cross-organisation access).
// `loading` mirrors the Supabase session load so callers can avoid redirecting
// before the session — and therefore the email — is known.
export const useIsSuperAdmin = () => {
  const { user, loading } = useSupabase();
  return { isSuperAdmin: isSuperAdminEmail(user?.email), loading };
};
